import SizingContainer from "common-utils/components/SizingContainer";
import { Artwork } from "kreate-common/modules/business-types";
import ButtonPrimary from "kreate-common/modules/kreate-ui/components/ButtonPrimary";
import ButtonSecondary from "kreate-common/modules/kreate-ui/components/ButtonSecondary";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import ModalV2 from "kreate-common/modules/kreate-ui/components/ModalV2";
import Image from "next/image";
import Link from "next/link";
import React from "react";

import pngBrushStroke from "./assets/brush-stroke.png";
import styles from "./index.module.scss";

import { EM_DASH } from "@/modules/common-utils/unicode";
import {
  getAssetFingerprint,
  getPoolPmUrl,
} from "@/modules/kreate-components/components/LinkPoolPm/utils";
import SecondaryFileViewer from "@/modules/kreate-components/components/SecondaryFileViewer";
import {
  getLinkToPageArtwork,
  getLinkToPageCollection,
} from "@/modules/navigation/utils/getLinkTo";

type Props = {
  open: boolean;
  onClose?: () => void;
  artwork: Artwork;
};

export default function ModalSuccessGachaMinting({
  open,
  onClose,
  artwork,
}: Props) {
  const assetFingerprint = getAssetFingerprint(artwork);
  const poolPmUrl = assetFingerprint
    ? getPoolPmUrl(assetFingerprint)
    : undefined;

  return (
    <ModalV2 open={open} onClose={onClose}>
      <ModalV2.Content className={styles.content} padding="none">
        <Flex.Col alignItems="center" gap="48px">
          <div className={styles.cardContainer}>
            <Image className={styles.background} src={pngBrushStroke} alt="" />
            <Flex.Col className={styles.card} padding="12px" gap="12px">
              <SizingContainer
                className={styles.imageContainer}
                sizing={{ type: "auto-height", aspectRatio: artwork.file }}
              >
                <SecondaryFileViewer
                  file={artwork.file}
                  thumbnailFile={artwork.imageFile}
                  sizes="212px"
                  fill
                />
              </SizingContainer>
              <Flex.Col gap="4px">
                <div className={styles.title}>
                  <Link
                    href={getLinkToPageArtwork(artwork)}
                    className={styles.link}
                  >
                    {artwork.title || EM_DASH}
                  </Link>
                </div>
                <div className={styles.collectionName}>
                  <span>
                    <em>{"Collection: "}</em>
                    <Link
                      href={
                        artwork.populated?.collection
                          ? getLinkToPageCollection(
                              artwork.populated.collection
                            )
                          : "#disabled"
                      }
                      className={styles.link}
                    >
                      {artwork.populated?.collection?.title || EM_DASH}
                    </Link>
                  </span>
                </div>
              </Flex.Col>
            </Flex.Col>
          </div>
          <Flex.Row className={styles.buttonGroup} gap="12px">
            <ButtonPrimary
              size="xl"
              content="View on Pool.pm"
              onClick={() =>
                poolPmUrl && window.open(poolPmUrl, "_blank", "noreferrer")
              }
              disabled={!poolPmUrl}
            />
            <ButtonSecondary size="xl" content="Close" onClick={onClose} />
          </Flex.Row>
        </Flex.Col>
      </ModalV2.Content>
    </ModalV2>
  );
}
